import config from 'config';

const LOAD = 'horse-racing/going/LOAD';
const LOAD_SUCCESS = 'horse-racing/going/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/going/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        going: segmentByDate(action.result)
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.horseRacing
      && globalState.horseRacing.going
      && globalState.horseRacing.going.loading;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(config.api.horseRacing.going, {params: {countryGroups: "UK,IRE"}})
  };
}

export function get(state) {
  return state.horseRacing.going.going;
}

function segmentByDate(data) {
  const byDate = {};

  data.forEach(race => {
    const {date} = race;
    byDate[date] = byDate[date] || [];
    byDate[date].push(race);
  });

  return byDate;
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/going.js